import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import StateLogger from "./StateLogger";
import { AIMEContextProvider } from "tot-loft-component-library";
import { Provider } from "react-redux";
import store from "./redux/store";
import { GoogleOAuthProvider } from "@react-oauth/google";

ReactDOM.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <Provider store={store}>
        <StateLogger />
        <AIMEContextProvider>
          <App />
        </AIMEContextProvider>
      </Provider>
    </GoogleOAuthProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
